import { selectPermissions } from "features/auth/authSlice"
import { useSelector } from "react-redux"

function HasPermission(permission) {
   
    const permissions = useSelector(selectPermissions)

    if(!permission)
        return false

    if(permissions){
        const isGranted = permissions?.indexOf(permission) > -1
        // if (isGranted == false) {
        //     console.warn("Permission required NOT GRANTED! (" + permission + ")")
        // }
        return isGranted
    } else {
        console.warn("Permission list null !")
        return false
    }

}



export const HasAnyOfThisPermissions = (requiredPermissions) => {

    const permissions = useSelector(selectPermissions);

    // Verifica che 'permissions' sia un array
    if (Array.isArray(permissions)) {
        // Usa il metodo 'some' per verificare se almeno un permesso richiesto è presente nella lista
        const isGranted = requiredPermissions.some(permission => permissions.indexOf(permission) > -1);

        // if (!isGranted) {
        //     console.warn("None of the required permissions are granted! (" + requiredPermissions.join(", ") + ")");
        // }

        return isGranted;
    } else {
        console.warn("Permission list is null or not an array!");
        return false;
    }
}

// Esporta una funzione come default export
export default HasPermission;

/** 
 * 
 * CORE 
 * 
 * */
// View
export const CanViewHisCompanyUsers = "CanViewHisCompanyUsers"
export const CanViewHisLog = "CanViewHisLog"
export const CanViewCompanyLog = "CanViewCompanyLog"
export const CanViewCompanyDetail = "CanViewHisCompanyDetail"

// Management
export const CanManageCompany = "CanEditCompany"
export const CanManageBusinessUnit = "CanManageBusinessUnit"
export const CanManageEmployees = "CanManageEmployee"
export const CanManagePrivacyPolicy = "CanManagePrivacyPolicy"
export const CanGrantCriticalRoles = "CanGrantCriticalRoles"


/** 
 * 
 * HR
 * 
 * */
export const CanSendAbsenceRequest = "CanSendAbsenceRequest"
export const CanViewAbsenceDailyStats = "CanViewAbsenceDailyStats"
export const CanManageAbsenceRequest = "CanManageAbsenceRequest"
export const CanViewAbsenceReports = "CanViewAbsenceReports"
export const CanManageWorkContracts = "CanManageWorkContracts"
export const CanManageOvertime = "CanManageOvertime"
export const CanViewHisOvertime = "CanViewHisOvertime"
export const CanSendCostRefund = "CanSendCostRefund"
export const CanManageCostRefund = "CanManageCostRefund"

// SAFETY
export const CanSendSafetyRequest = "CanSendSafetyRequest"
export const CanManageSafetyRequest = "CanManageSafetyRequest"
export const CanManageSafetySettings = "CanManageSafetySettings"

// HEALTH
export const CanSendHealthData = "CanSendHealthData"
export const CanManagePatients = "CanManagePatients"
export const CanManageHealthPolicy = "CanManageHealthPolicy"

// DEVICES
export const CanViewDevices = "CanViewDevices"
export const CanManageDevices = "CanManageDevices"

// WHISTLE
export const CanSendWhistle = "CanSendWhistle"
export const CanViewHisWhistle = "CanViewHisWhistle"
export const CanManageWhistle = "CanManageWhistle"


// ADMIN
export const CanManagePlatform = "CanManagePlatform"